/* eslint-disable import/prefer-default-export */
export const matchPathname = (word) => window.location.href.indexOf(word) > -1;
